var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmimg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 85,
    viewBox: "0 0 153 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0343711 49.9733C0.614371 33.7332 16.2744 26.7733 31.9344 18.6533C50.4944 8.79325 61.5144 -1.06675 84.7144 0.0932526C107.914 1.25325 122.994 12.2733 124.734 27.9333C126.474 43.0133 147.354 49.9733 151.994 65.0533C156.634 80.1332 135.754 85.3532 114.874 82.4532C90.5144 78.9733 75.4344 88.2533 52.2344 82.4532C27.2944 76.0732 -1.12563 71.4333 0.0343711 49.9733Z",
    fill: "url(#paint0_linear_929_3424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9156 83.613C104.542 83.613 125.316 79.9776 125.316 75.493C125.316 71.0085 104.542 67.373 78.9156 67.373C53.2896 67.373 32.5156 71.0085 32.5156 75.493C32.5156 79.9776 53.2896 83.613 78.9156 83.613Z",
    fill: "#EAE4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2271 12.2729H49.6831C45.9673 12.2729 42.9551 15.2852 42.9551 19.0009V65.865C42.9551 69.5807 45.9673 72.593 49.6831 72.593H94.2271C97.9428 72.593 100.955 69.5807 100.955 65.865V19.0009C100.955 15.2852 97.9428 12.2729 94.2271 12.2729Z",
    fill: "url(#paint1_linear_929_3424)",
    stroke: "#B49CF7",
    strokeWidth: 1.044
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4006 26.1929H56.4126C55.3876 26.1929 54.5566 27.0238 54.5566 28.0489C54.5566 29.0739 55.3876 29.9049 56.4126 29.9049H90.4006C91.4257 29.9049 92.2566 29.0739 92.2566 28.0489C92.2566 27.0238 91.4257 26.1929 90.4006 26.1929Z",
    fill: "#9B7AF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6006 37.7925H56.4126C55.3876 37.7925 54.5566 38.6234 54.5566 39.6485C54.5566 40.6735 55.3876 41.5045 56.4126 41.5045H84.6006C85.6257 41.5045 86.4566 40.6735 86.4566 39.6485C86.4566 38.6234 85.6257 37.7925 84.6006 37.7925Z",
    fill: "#9B7AF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2606 49.3926H56.4126C55.3876 49.3926 54.5566 50.2235 54.5566 51.2486C54.5566 52.2736 55.3876 53.1046 56.4126 53.1046H71.2606C72.2857 53.1046 73.1166 52.2736 73.1166 51.2486C73.1166 50.2235 72.2857 49.3926 71.2606 49.3926Z",
    fill: "#9B7AF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.955 75.842C109.156 75.842 115.803 69.1943 115.803 60.994C115.803 52.7937 109.156 46.146 100.955 46.146C92.7551 46.146 86.1074 52.7937 86.1074 60.994C86.1074 69.1943 92.7551 75.842 100.955 75.842Z",
    fill: "url(#paint2_linear_929_3424)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.415 60.9928L98.635 66.2128L109.075 54.6128",
    stroke: "white",
    strokeWidth: 3.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.615 33.1529L121.255 26.7729L116.615 33.1529Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M116.615 33.1529L121.255 26.7729",
    stroke: "url(#paint3_linear_929_3424)",
    strokeWidth: 2.32,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M122.994 41.8528L129.374 40.1128L122.994 41.8528Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.994 41.8528L129.374 40.1128",
    stroke: "url(#paint4_linear_929_3424)",
    strokeWidth: 2.32,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.994 51.1323L129.374 54.0323L122.994 51.1323Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.994 51.1323L129.374 54.0323",
    stroke: "url(#paint5_linear_929_3424)",
    strokeWidth: 2.32,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_929_3424",
    x1: 0,
    y1: 0,
    x2: 71.4931,
    y2: 129.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_929_3424",
    x1: 42.9551,
    y1: 12.2729,
    x2: 103.229,
    y2: 70.2284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_929_3424",
    x1: 86.1074,
    y1: 46.146,
    x2: 115.803,
    y2: 75.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4810E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_929_3424",
    x1: 116.615,
    y1: 26.7729,
    x2: 122.685,
    y2: 31.1872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4810E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_929_3424",
    x1: 122.994,
    y1: 40.1128,
    x2: 123.878,
    y2: 43.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4810E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_929_3424",
    x1: 122.994,
    y1: 51.1323,
    x2: 125.179,
    y2: 55.9392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4810E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmimg);
export default __webpack_public_path__ + "static/media/Confirmimg.8c3f61e984674deb45c72b50dc27dcfe.svg";
export { ForwardRef as ReactComponent };